import { render, staticRenderFns } from "./payPlatformSuccess.vue?vue&type=template&id=a580fcca&scoped=true"
import script from "./payPlatformSuccess.vue?vue&type=script&lang=js"
export * from "./payPlatformSuccess.vue?vue&type=script&lang=js"
import style0 from "./payPlatformSuccess.vue?vue&type=style&index=0&id=a580fcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a580fcca",
  null
  
)

export default component.exports